import React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";
import { ImageBorderRadiusWrapper } from "@brexhq/next/src/components/shared/BynderAsset/Image/BynderImage";
import {
  BodyM,
  BodyS,
  TitleXS,
} from "@brexhq/shared/components/Typography/Components";
import { ModuleThemeType } from "@brexhq/shared/types/ModuleTheme";
import { buildUrlFromSlug } from "@brexhq/shared/utils/buildUrlFromSlug";

import { ArticleData } from "../../../utils/repeatableContent/repeatableContentUtils";
import { getModuleThemeColors } from "../../pageBuilder/ModuleLayout";
import { BynderAsset } from "../../shared/BynderAsset/BynderAsset";
import { Link } from "../../shared/Link/Link";
import { getButtonText } from "../ArticleLinkList/ArticleLinkList";

type Props = {
  article: ArticleData;
  theme: ModuleThemeType;
  displayOptions: {
    showExcerpt: boolean;
    showArticleGroup: boolean;
  };
};

export const StackStyle: React.FC<Props> = ({
  article,
  theme,
  displayOptions,
}) => {
  const url = buildUrlFromSlug({
    pageType: article.page._type,
    slug: article.slug.current,
    parent:
      article.page._type === "contentHubArticle"
        ? article.page.content.articleGroup?.parent
        : "journal",
  });

  const { textPrimary } = getModuleThemeColors(theme).standard;

  return (
    <Container
      direction={"column"}
      gap="xsml"
      margin={[0, 0, 0, 0]}
      maxWidth={"750px"}
    >
      <ImageBorderRadiusWrapper mediaStyle={{ borderRadius: "30px" }}>
        <BynderAsset asset={article.page.content.articleImage.image} />
      </ImageBorderRadiusWrapper>
      {displayOptions.showArticleGroup && (
        <>
          {article.page._type === "contentHubArticle" ? (
            article.page.content.articleGroup && (
              <BodyS color={textPrimary}>
                {article.page.content.articleGroup.name}
              </BodyS>
            )
          ) : (
            <BodyS color={textPrimary}>Press Release</BodyS>
          )}
        </>
      )}
      <span>
        <TitleXS color={textPrimary}>{article.page.meta.title}</TitleXS>
        {displayOptions.showExcerpt && (
          <BodyM color={textPrimary}>{article.page.content.excerpt}</BodyM>
        )}
      </span>
      <Link
        modifier={"arrow"}
        to={url}
        label={getButtonText(article)}
        component="ArticleLinkList"
        theme={theme}
      />
    </Container>
  );
};
